import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-italic text-disabled"
}

import { computed, onMounted, onUnmounted } from "vue"
import { onBeforeRouteLeave } from "vue-router"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxSpinner',
  props: {
  text: {
    type: String,
    required: true,
  },

  disableActions: {
    type: Boolean,
    default: false,
  },

  fixedCenter: {
    type: Boolean,
    default: true,
  },
},
  setup(__props) {

const props = __props

//endregion

//region Variables

const classes = computed(() => {
  return { "fixed-center": props.fixedCenter }
})

//endregion

if (props.disableActions) {
  //region Variables

  const htmlBodyElement = document.querySelector("body")
  const disableClass = "disable-user-action"

  //endregion

  //region Lifecycle

  onMounted(async () => {
    if (htmlBodyElement) {
      htmlBodyElement.classList.add(disableClass)
    }
  })

  onUnmounted(async () => {
    if (htmlBodyElement) {
      htmlBodyElement.classList.remove(disableClass)
    }
  })

  onBeforeRouteLeave((to, from, next) => {
    next(false)
  })
}

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_spinner_ball = _resolveComponent("q-spinner-ball")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["column text-center items-center", classes.value])
  }, [
    _createVNode(_component_q_spinner_ball, {
      class: "q-mb-lg",
      color: "secondary",
      size: "4em"
    }),
    (props.text)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(props.text), 1))
      : _createCommentVNode("", true)
  ], 2))
}
}

})